<div *ngIf="mailInfo.matching_score" class="matching_score">
  {{
    mailInfo.matching_score.matching_score_1
      | matchingScore
  }}
</div>

<div class="card-heaader-box" *ngIf="mailType === 'project'">
  <table *ngIf="!isAbleToEdit; else ableToEditProject">
    <tr>
      <td colspan="3" class="item"
        [ngClass]="{'item-reject': rejected('receipt_datetime_search')}"
        *ngIf="!mailInfo.mail_register_id">
          日:&nbsp;{{ mailInfo.receipt_datetime | date: 'MM/dd HH:mm' }}
      </td>
      <td colspan="4" class="item item-mail-from" placement="bottom" ngbTooltip="{{ mailInfo.mail_from }}" container="body"
        [ngClass]="{'item-reject': rejected('mail_from_search')||rejected('bp_rank_search')}">送:&nbsp;{{ mailInfo.mail_from }}</td>
      <td class="item item-location" (click)="locationService.openMap(mailInfo, pairMail)"
        [ngClass]="{'item-reject': rejected('work_location_search')}">
        所:&nbsp;<span [ngClass]="{ link: pairMail?.work_location }">{{
          mailInfo.work_location
        }}</span>
        <span *ngIf="mailInfo.distance" class="distance">&nbsp;{{ mailInfo.distance }}km</span>
      </td>
    </tr>
    <tr>
      <td class="item" [ngClass]="{'item-reject': rejected('fee_search')}">
        金:&nbsp;<div [innerHtml]="mailInfo.fee | fee:mailInfo.estimate_fee"></div>
      </td>
      <td class="item" [ngClass]="{'item-reject': rejected('age_search')}">齢:&nbsp;{{ mailInfo.age | age }}</td>
      <td class="item" [ngClass]="{'item-reject': rejected('ncc_search')}">商:&nbsp;{{
          mailInfo.number_of_connect_company
            | modifyNumberOfConnectCompanyForWorker
        }}</td>
      <td class="item" [ngClass]="{'item-reject': rejected('employment_status_search')}">個:&nbsp;{{
          mailInfo.employment_status | modifyEmploymentStatusTextForProject
        }}</td>

      <td class="item" [ngClass]="{'item-reject': rejected('country_of_citizenship_search')}">国:&nbsp;{{
          mailInfo.country_of_citizenship | checkOutsideOfJapan: 'project'
        }}</td>
      <td class="item" [ngClass]="{'item-reject': rejected('begin_at_search')}">始:&nbsp;
        {{ mailInfo.work_immidiately | modifyWorkImmidiatelyText }}</td>
      <td class="item" [ngClass]="{'item-reject': rejected('interview_times_search')}">面:&nbsp;{{
          mailInfo.interview_times | modifyInterviewCountText
        }}</td>
      <td class="item" [ngClass]="{'item-reject': rejected('non_transmited_number_search')}">再:&nbsp;{{
          mailInfo.transmited_number | countReceivedTimes
        }}</td>
    </tr>
  </table>

  <ng-template #ableToEditProject>
    <div class="edit" (click)="preventClickEvent($event)">
      <p>
        <span class="item" *ngIf="!mailInfo.mail_register_id">
          日:&nbsp;{{ mailInfo.receipt_datetime | date: 'y/MM/dd HH:mm' }}
        </span>
        <span class="item item-mail-from">送:&nbsp;{{ mailInfo.mail_from }}</span>
        <span class="item">所:&nbsp;<input type="text" [(ngModel)]="mailInfo.work_location" /></span>
      </p>
      <p>
        <span class="item">金:&nbsp;<input type="number" [(ngModel)]="mailInfo.fee" /></span>
        <span class="item">齢:&nbsp;<input type="number" [(ngModel)]="mailInfo.age" /></span>
        <span class="item">商:&nbsp;
          <select class="select" [(ngModel)]="mailInfo.number_of_connect_company">
            <option value="0">０</option>
            <option value="1">１</option>
            <option value="2">２</option>
            <option value="3">３</option>
            <option value="">指定なし</option>
          </select>
        </span>
        <span class="item">個:&nbsp;
          <select class="select" [(ngModel)]="mailInfo.employment_status">
            <option value="contract_employee">NG</option>
            <option value="solo_worker">OK</option>
            <option value="">指定なし</option>
          </select>
        </span>

        <span class="item">国:&nbsp;
          <select class="select" [(ngModel)]="mailInfo.country_of_citizenship">
            <option value="JPN">NG</option>
            <option value="ANY">OK</option>
            <option value="">指定なし</option>
          </select>
        </span>
        <span class="item">始:&nbsp;
          <select class="select" [(ngModel)]="mailInfo.work_immidiately">
            <option value="0" selected="">-</option>
            <option value="即">即日</option>
            <option value="1月">1月</option>
            <option value="2月">2月</option>
            <option value="3月">3月</option>
            <option value="4月">4月</option>
            <option value="5月">5月</option>
            <option value="6月">6月</option>
            <option value="7月">7月</option>
            <option value="8月">8月</option>
            <option value="9月">9月</option>
            <option value="10月">10月</option>
            <option value="11月">11月</option>
            <option value="12月">12月</option>
          </select>
        </span>
        <span class="item">面:&nbsp;
          <select class="select" [(ngModel)]="mailInfo.interview_times">
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="">指定なし</option>
          </select>
        </span>
        <span class="item" *ngIf="
            mailInfo.non_transmited_number !== '{}' &&
            mailInfo.non_transmited_number !== null
          ">
          再:&nbsp;{{ mailInfo.non_transmited_number | countReceivedTimes }}
        </span>
      </p>
      <div class="btn-box">
        <button class="btn btn-cancel" (click)="cancelCorrectingMailInfo($event)">
          キャンセル
        </button>
        <button class="btn btn-send" (click)="sendCorrectedMailInfo()">
          完了
        </button>
      </div>
    </div>
  </ng-template>

  <p class="keywords-area">
    <span class="key-words highlight matched" *ngFor="let key of skillSearchMatched">{{key}}</span>
    <span class="key-words highlight " *ngFor="let key of skillSearchUnmatched">{{key}}</span>
    <span class="key-words matched" *ngFor="let key of matchedKeywords">{{key}}</span>
    <span class="key-words" *ngFor="let key of unMatchedKeywords">{{key}}</span>
  </p>
</div>

<div class="card-heaader-box" *ngIf="mailType === 'worker'">
  <table *ngIf="!isAbleToEdit; else ableToEditWorker">
    <tr>
      <td colspan="3" class="item"
        [ngClass]="{'item-reject': rejected('receipt_datetime_search')}"
        *ngIf="!mailInfo.mail_register_id">
          日:&nbsp;{{ mailInfo.receipt_datetime | date: 'MM/dd HH:mm' }}
      </td>
      <td colspan="4" class="item item-mail-from" placement="bottom" ngbTooltip="{{ mailInfo.mail_from }}"  container="body"
        [ngClass]="{'item-reject': rejected('mail_from_search')||rejected('bp_rank_search')}">送:&nbsp;{{ mailInfo.mail_from }}</td>
      <td class="item item-location" (click)="locationService.openMap(mailInfo, pairMail)"
        [ngClass]="{'item-reject': rejected('work_location_search')}">
        所:&nbsp;<span [ngClass]="{ link: pairMail?.work_location }">{{
          mailInfo.work_location
        }}</span>
        <span *ngIf="mailInfo.distance" class="distance">&nbsp;{{ mailInfo.distance }}km</span>
      </td>
    </tr>
    <tr>
      <td class="item" [ngClass]="{'item-reject': rejected('fee_search')}">
        金:&nbsp;<div [innerHtml]="mailInfo.fee | fee:mailInfo.estimate_fee"></div>
      </td>
      <td class="item" [ngClass]="{'item-reject': rejected('age_search')}">齢:&nbsp;{{ mailInfo.age | age }}</td>
      <td class="item" [ngClass]="{'item-reject': rejected('ncc_search')}">商:&nbsp;{{
          mailInfo.number_of_connect_company
            | modifyNumberOfConnectCompanyForWorker
        }}</td>
      <td class="item" [ngClass]="{'item-reject': rejected('employment_status_search')}">雇:&nbsp;{{
          mailInfo.employment_status | modifyEmploymentStatusTextForWorker
        }}</td>

      <td class="item" [ngClass]="{'item-reject': rejected('country_of_citizenship_search')}">国:&nbsp;{{
          mailInfo.country_of_citizenship | translateCountryOfCitizenshipText
        }}</td>
      <td class="item" [ngClass]="{'item-reject': rejected('begin_at_search')}">始:&nbsp;{{
          mailInfo.work_immidiately | modifyWorkImmidiatelyText
        }}</td>
      <td class="item" [ngClass]="{'item-reject': rejected('interview_times_search')}">面:&nbsp;{{
          mailInfo.interview_times | modifyInterviewCountText
        }}</td>
      <td class="item" [ngClass]="{'item-reject': rejected('non_transmited_number_search')}">再:&nbsp;{{
          mailInfo.transmited_number | countReceivedTimes
        }}</td>
    </tr>
  </table>

  <ng-template #ableToEditWorker>
    <div class="edit" (click)="preventClickEvent($event)">
      <p>
        <span class="item" *ngIf="!mailInfo.mail_register_id">
          日:&nbsp;{{ mailInfo.receipt_datetime | date: 'y/MM/dd HH:mm' }}
        </span>
        <span class="item item-mail-from">送:&nbsp;{{ mailInfo.mail_from }}</span>
        <span class="item">所:&nbsp;<input type="text" [(ngModel)]="mailInfo.work_location" /></span>
      </p>
      <p>
        <span class="item">金:&nbsp;<input type="number" [(ngModel)]="mailInfo.fee" /></span>
        <span class="item">齢:&nbsp;<input type="number" [(ngModel)]="mailInfo.age" /></span>
        <span class="item">商:&nbsp;
          <select class="select" [(ngModel)]="mailInfo.number_of_connect_company">
            <option value="0">０</option>
            <option value="1">１</option>
            <option value="2">２</option>
            <option value="3">３</option>
            <option value="">指定なし</option>
          </select>
        </span>
        <span class="item">雇:&nbsp;
          <select class="select" [(ngModel)]="mailInfo.employment_status">
            <option value="direct_agreement">社員</option>
            <option value="solo_worker">個人</option>
            <option value="">指定なし</option>
          </select>
        </span>

        <span class="item">国:&nbsp;
          <select class="select" [(ngModel)]="mailInfo.country_of_citizenship">
            <option value="JPN">日本</option>
            <option value="CHN">中国</option>
            <option value="VNM">ベトナム</option>
            <option value="KOR">韓国</option>
            <option value="MMR">ミャンマー</option>
            <option value="MNG">モンゴル</option>
            <option value="XXX">その他</option>
            <option value="">指定なし</option>
          </select>
        </span>
        <span class="item">始:&nbsp;
          <select class="select" [(ngModel)]="mailInfo.work_immidiately">
            <option value="0" selected="">-</option>
            <option value="即">即日</option>
            <option value="1月">1月</option>
            <option value="2月">2月</option>
            <option value="3月">3月</option>
            <option value="4月">4月</option>
            <option value="5月">5月</option>
            <option value="6月">6月</option>
            <option value="7月">7月</option>
            <option value="8月">8月</option>
            <option value="9月">9月</option>
            <option value="10月">10月</option>
            <option value="11月">11月</option>
            <option value="12月">12月</option>
          </select>
        </span>
        <span class="item">面:&nbsp;
          <select class="select" [(ngModel)]="mailInfo.interview_times">
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="">指定なし</option>
          </select>
        </span>
        <span class="item" *ngIf="
            mailInfo.non_transmited_number !== '{}' &&
            mailInfo.non_transmited_number !== null
          ">
          再:&nbsp;{{ mailInfo.non_transmited_number | countReceivedTimes }}
        </span>
      </p>
      <div class="btn-box">
        <button class="btn btn-cancel" (click)="cancelCorrectingMailInfo($event)">
          キャンセル
        </button>
        <button class="btn btn-send" (click)="sendCorrectedMailInfo()">
          完了
        </button>
      </div>
    </div>
  </ng-template>
  <p class="keywords-area">
    <span class="key-words highlight matched" *ngFor="let key of skillSearchMatched">{{key}}</span>
    <span class="key-words highlight " *ngFor="let key of skillSearchUnmatched">{{key}}</span>
    <span class="key-words matched" *ngFor="let key of matchedKeywords">{{key}}</span>
    <span class="key-words" *ngFor="let key of unMatchedKeywords">{{key}}</span>
  </p>
</div>
